import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_accounting_seat'

const updateAccountingSeat = async (id, object) => {
    try {
        const response = await axios.put(
            route + '/' + id,
            object
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}

export { updateAccountingSeat }
